import {isUndefined} from './is-undefined';
import {isNull} from './is-null';

export function isNil(value) {
    return isUndefined(value) || isNull(value);
}
